/* eslint-disable @next/next/no-sync-scripts */
/* eslint-disable react/no-danger */
import { topOverlayCSS } from "../../utils/stylesUtil/topOverlay";
import { seoBaseMin } from "../../utils/stylesUtil/seoBase";
import { jqueryUIMinCss } from "../../utils/stylesUtil/jqueryUIMin";
import { bankOfferCSS } from "../../utils/stylesUtil/bankOffer";
import { baseMinCss } from "../../utils/stylesUtil/baseMin";
import { seoFlightsCss } from "../../utils/stylesUtil/seoFlights";
import { flightInlinceCss } from "../../utils/stylesUtil/flightsInline";

export const appendHeadCityDT = (props) => {
  const {
    jsSettingJson,
    appConfig,
    tokenJson,
    preloaded_state: preLoadedState,
    intid,
    devId,
    mcid,
    tokens,
    isIntl,
    template_type: templateType,
    ccde,
    currentDomainName,
    lang,
    isGoibibo = false,
    pageLoad = {},
    region = "IN",
  } = props || {};
  let cssPath;
  let jsPath;
  // let imagePath;
  // let minExt;
  // let topOverlayPath;
  let gliderPath;
  let seoListingPath;
  let staticWidgetPath;
  let flightIndex;
  let webVitalsPath;

  if (appConfig && appConfig.liveMode) {
    cssPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css`;
    jsPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js`;
    // imagePath = `${appConfig.imagePath}/images`;
    // minExt = '.min';
    gliderPath = `${jsPath}/glider.min.js`;
    seoListingPath = `${cssPath}/seoListing.min.css`;
    staticWidgetPath =
      lang && lang === "hin"
        ? `${jsPath}/hiStaticSeoWidget.min.js`
        : `${jsPath}/staticSeoWidget.min.js`;
    webVitalsPath = `${jsPath}/webVitalsScript.min.js`;
  } else {
    cssPath = "http://localhost:3000/_next/static/css";
    jsPath = "http://localhost:3000/_next/static/js";
    // imagePath = '/images';
    // minExt = '';
    gliderPath = `${jsPath}/glider.min.js`;
    seoListingPath = `${cssPath}/seoListing.min.css`;
    staticWidgetPath =
      lang && lang === "hin"
        ? `${jsPath}/hiStaticSeoWidget.min.js`
        : `${jsPath}/staticSeoWidget.min.js`;
    webVitalsPath = `${jsPath}/webVitalsScript.min.js`;
  }
  const tokenJsonString =
    tokenJson && tokenJson.length !== 0
      ? `var tokenJson = ${JSON.stringify(tokenJson)}`
      : 'var tokenJson = {"prefilledDestCity":{"country":"India","iata":"BOM","city":"Mumbai, India","value":"Mumbai (BOM)"},"tokensList":{},"prefilledSrcCity":{"country":"India","iata":"DEL","city":"New Delhi, India","value":"New Delhi (DEL)"}};';
  return (
    <>
      <link rel="icon" type="image/x-icon" href="https://www.makemytrip.com/favicon.ico" />
      <link href="https://imgak.mmtcdn.com" rel="preconnect" crossorigin />
      <link href="http://imgak.mmtcdn.com" rel="preconnect" crossorigin />
      <link href="https://jsak.mmtcdn.com" rel="preconnect" crossorigin />
      <link href="https://cssak.mmtcdn.com" rel="preconnect" crossorigin />
      <link href="https://bid.g.doubleclick.net" rel="preconnect" crossorigin />
      <link href="http://makemytrip.tt.omtrdc.net" rel="preconnect" crossorigin />
      <style dangerouslySetInnerHTML={{ __html: seoBaseMin }} />
      <link href={`${cssPath}/bootstrap.min.css`} rel="stylesheet" />
      {isGoibibo ? (
        <link href={`${cssPath}/dweb-header.min.css`} rel="stylesheet" />
      ) : (
        <link href={`${cssPath}/header.min.css`} rel="stylesheet" />
      )}
      <style dangerouslySetInnerHTML={{ __html: jqueryUIMinCss }} />
      <style dangerouslySetInnerHTML={{ __html: bankOfferCSS }} />
      <style dangerouslySetInnerHTML={{ __html: topOverlayCSS }} />
      <style dangerouslySetInnerHTML={{ __html: baseMinCss }} />
      <style dangerouslySetInnerHTML={{ __html: flightInlinceCss }} />
      <link href={`${cssPath}/flightNewIndexLanding.min.css`} rel="stylesheet" />
      <style dangerouslySetInnerHTML={{ __html: seoFlightsCss }} />
      <script type="text/javascript" src="https://code.jquery.com/jquery-3.5.1.min.js" />
      <script src="https://code.jquery.com/ui/1.13.2/jquery-ui.min.js" />
      <script type="text/javascript" src={`${jsPath}/jquery-ui-flights.min.js`} />
      <style>
        {
          '@media screen and (max-width:768px){.modify-search-header-components.inOverlay{margin-top:0}.modify-search-header{padding:0;z-index:2}.seo-header h1{padding-bottom:20px;margin-bottom:0}.seo-header{background:#0a223d}}@media screen and (max-width:768px){.fli-intl-container{padding-top:170px}.fli-intl-container{width:90%}}@media screen and (max-width:480px){body{overflow-x:hidden}}@media screen and (min-width:1200px){.makeCenterCol{max-width:1200px!important;padding-left:0!important;padding-right:0!important;margin:0 auto!important;float:none!important}}.seoContentMiddle.airline-dtls-view{margin-top:20px!important;padding:0!important}.breadcrumb{padding:8px 15px;margin:0!important;list-style:none;background-color:#fff;border-radius:10px;border:1px solid #d8eaff;display:flex}.breadcrumb>.active{color:#777}.breadcrumb>li,.pagination{display:flex}.breadcrumb a{color:#006dff;text-decoration:none;cursor:pointer}.breadcrumb>li+li:before{padding:5px 5px;color:#aaa;content:"/\u00a0";font-size:18px}#seoContentTop{background-image:linear-gradient(to right,#fff,#e8fde9);color:#000;align-items:center;padding:10px;border-radius:2px;box-shadow:0 2px 4px 0 rgb(0 0 0 / 15%);line-height:18px;margin:10px 0}img{position:relative}img[alt]:after{display:block;position:absolute;top:0;left:0;width:100%;height:100%;background-color:#fff;font-weight:var(--font-bolder, 900);line-height:1;text-align:center;content:attr(alt)}.appendBottom16{margin-bottom:16px}'
        }
      </style>
      <script type="text/javascript">
        {`window.FLTS = {};
        window.FLTS.listingStartTime = ${Date.now()};`}
      </script>
      <style>
        {"@media screen and (min-width: 768px) {.fli-intl-container {padding-top: 0;}}"}
      </style>
      {/* { airlineCode ? <script>{ `var airlineCode = ${airlineCode || ''}`}</script> : <></>} */}
      <link href={`${seoListingPath}`} rel="stylesheet" />
      <script defer type="text/javascript" src={`${gliderPath}`} />
      <script
        dangerouslySetInnerHTML={{
          __html: `
       var currentDateddMMyy = '${tokens?.cheap_ddMMyy || ""}';
       window.pageLoad = ${JSON.stringify(pageLoad)};
       window.isSeoMain = true;
       window.seoUrl = "${tokens?.url || ""}";
       window.lang = "${lang || ""}";
       window.currentDomain = "${currentDomainName || ""}";
       window.devId = "${devId || ""}";
       window.mcid = "${mcid || ""}";
       window.seoScreenParams = {trip : 'oneWay',
                         classtype : 'E',
                         fromcityname : '${tokens?.src_city_name || ""}',
                         tocityname   : '${tokens?.dest_city_name || ""}',
                         fromcity : '${tokens?.src_city_code || ""}',
                         tocity   : '${tokens?.dest_city_code || ""}',
                         childcount : 0,
                         infantcount : 0,
                         adultcount : 1,
                         depdate : '${tokens?.cheap_MMddyyyy || ""}',
                         isIntl : false,
                         airlinecode : '${tokens?.airline_code || ""}'};
       window.urlParamsString = "?trip=oneWay&classtype=E&fromcity=${
         tokens?.src_city_code || ""
       }&tocity=${tokens?.dest_city_code || ""}&fromcityname=${
            tokens?.src_city_name || ""
          }&tocityname=${
            tokens?.dest_city_name || ""
          }&childcount=0&adultcount=1&infantcount=0&depdate=${
            tokens?.cheap_MMddyyyy || ""
          }&isIntl=false";
      `,
        }}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
      window.__PRELOADED_STATE__ = '${preLoadedState || ""}';
      window.showLeaveIntent = true;
      var mbox_id = 'New_homepage_Hero', top_mbox_id = 'HPLP_Topbar_New', dealsPerLoad = '12', dealMaxLoad = '48', voyagerURL = '//voyager.goibibo.com/api/v1/flights_search/find_node_by_name_v2/?limit=15&amp;country_filter_id=5597365951189135149', voyagerTimeout = '3000';
      var jsSettingJson = ${JSON.stringify(jsSettingJson)};
      ${appConfig?.settings ? `var flightsettings = ${JSON.stringify(appConfig.settings)};` : ""};
      ${tokenJsonString}
      var intid = "${intid || ""}";
      var mmt = {};
      mmt.hlp = {};
      var device = 'desktop';
      window.isIntl = ${isIntl || false};
      var pageType = 'home', WEBSITE_URL = '//www.makemytrip.com', funnel_URL = '', mouseRecorder = '', serverTodayDate = new Date(), serverTime = new Date(), noOfDaysToAddInDept = ${
        tokenJson?.noOfDaysToAddInDept
      }, noOfDaysToAddInReturn = ${tokenJson?.noOfDaysToAddInReturn};
      var template = '${templateType}';
      window.template = '${templateType}';
      let ccdeVal = '${region ? `&ccde=${region}` : "&ccde=IN"}';
      `,
        }}
      />
      <script defer type="text/javascript" src={`${staticWidgetPath}`} />
      <script defer type="module" src={`${webVitalsPath}`} />
      <script
        dangerouslySetInnerHTML={{
          __html:
            '$(document).ready(function(){$(".viewFareBtn").click(function(e){e.preventDefault();$(this);let t=document.getElementsByClassName("hideCheapCards"),n=document.getElementById("viewFareBtn");if(n.parentNode.removeChild(n),t.length>0)for(var a=0;a<=t.length;a++)t[a]&&t[a].classList.remove("hideCheapCards")})});',
        }}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
      window.addEventListener('load', function () {
        new Glider(document.querySelector('.bankOfferItemWrapper'), {
            slidesToShow: 1,
            slidesToScroll: 1,
            scrollLock: true,
            dots: '',
            arrows: {
              prev: '.btn-prev',
              next: '.btn-next',
            },
    
            responsive: [
              {
                breakpoint: 775,
                settings: {
                  slidesToShow: 'auto',
                  slidesToScroll: 'auto',
                  itemWidth: 150,
                  duration: 0.80
                }
              }, {
                breakpoint: 1024,
                scrollLock: true,
                settings: {
                  slidesToShow: 1.1,
                  slidesToScroll: 1,
                  itemWidth: 150,
                  duration: 0.80,
    
                }
              }
            ]
          },
        );
      });
      `,
        }}
      />
    </>
  );
};
